import gsap from 'gsap';

class Tabs {
  constructor(props) {
    this.activeClassName = 'active';
    this.tabClassName = 'tab';
    this.el = props.el;
    this.elButtons = this.el.querySelectorAll('.tabs__navigation button');
    this.changeTab = this.changeTab.bind(this);
    this.init();
  }

  init() {
    this.elButtons.forEach((button) => {
      button.addEventListener('click', this.changeTab);
    });
    const currentButton = this.el.querySelector(
      '.tabs__navigation button.active'
    );
    this.animateIndicator(currentButton);
  }

  changeTab(event) {
    const { currentTarget } = event;
    const id = currentTarget.getAttribute('data-id');
    const currentButton = this.el.querySelector(
      '.tabs__navigation button.active'
    );
    if (currentTarget === currentButton) return;

    const currentTab = this.el.querySelector(
      `.${this.tabClassName}.${this.activeClassName}`
    );
    const activeTab = this.el.querySelector(
      `.${this.tabClassName}[data-id="${id}"]`
    );
    if (currentButton) {
      currentButton.classList.remove(this.activeClassName);
    }
    currentTab.classList.remove(this.activeClassName);
    currentTarget.classList.add(this.activeClassName);
    activeTab.classList.add(this.activeClassName);
    this.animateIndicator(currentTarget);
  }

  animateIndicator(el) {
    if (!el) {
      return;
    }
    const btnTabTop = el.offsetTop;
    const btnTabHeight = el.offsetHeight;
    const tabIndicator = this.el.querySelector('[data-tab-indicator]');
    const tabIndicatorAnim =
      tabIndicator &&
      tabIndicator.dataset &&
      tabIndicator.dataset.tabIndicatorAnim;

    let animValues = {
      height: btnTabHeight,
      y: btnTabTop,
    };

    if (tabIndicatorAnim && tabIndicatorAnim === 'width') {
      const btnTabWidth = el.offsetWidth;
      const btnTabLeft = el.offsetLeft;
      animValues = {
        width: btnTabWidth,
        x: btnTabLeft,
      };
    }

    gsap.to(tabIndicator, {
      duration: 0.3,
      ...animValues,
    });
  }
}

export default Tabs;
